
import MoneyRecive from "../../../assets/outline/MoneyRecive.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MoneyReciveIcon({ className, dataTestid = "MoneyReciveIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MoneyRecive data-testid={dataTestid} className={classes} {...rest} />
  );
}
